function mainMenu(){
  // Open submenu on click
  $(".js-desktop-menu .menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();

    // If current link is already open, close submenu
    if (
      $(this).closest(".menu-item-has-children").hasClass("sub-menu-open")
    ) {
      $(".top-nav").removeClass("sub-menu-open");
      $(".js-menu-overlay").removeClass("sub-menu-open");
      $(this).closest(".menu-item-has-children").removeClass("sub-menu-open");
      $(this).next(".sub-menu-wrap").removeClass("sub-menu-open");
    } else {
      $(".menu-item-has-children").removeClass("sub-menu-open");
      $(".sub-menu-wrap").removeClass("sub-menu-open");
      $(".top-nav").addClass("sub-menu-open");
      $(".js-menu-overlay").addClass("sub-menu-open");

      $(this).closest(".menu-item-has-children").toggleClass("sub-menu-open");
      $(this).next(".sub-menu-wrap").toggleClass("sub-menu-open");
    }
  });

  // Open menu with tabs - accessibility
  $(".js-desktop-menu .sub-menu-wrap a").on("focusin", function () {
    $(this).closest(".menu-item-has-children").addClass("sub-menu-open");
    $(this).closest(".sub-menu-wrap").addClass("sub-menu-open");
    $(".top-nav").toggleClass("sub-menu-open");
    $(".js-menu-overlay").toggleClass("sub-menu-open");
  });
  $(".js-desktop-menu .sub-menu-wrap a").on("focusout", function () {
    $(this).closest(".menu-item-has-children").removeClass("sub-menu-open");
    $(this).closest(".sub-menu-wrap").removeClass("sub-menu-open");
    $(".top-nav").toggleClass("sub-menu-open");
    $(".js-menu-overlay").toggleClass("sub-menu-open");
  });

  // Close on click outside.
  $(document).on("click", function (e) {
    if (
      !$(e.target).parent().hasClass("menu-item") &&
      $(".sub-menu-wrap").has(e.target).length === 0
    ) {
      $(".menu-item-has-children").removeClass("sub-menu-open");
      $(".sub-menu-wrap").removeClass("sub-menu-open");
      $(".top-nav").removeClass("sub-menu-open");
      $(".js-menu-overlay").removeClass("sub-menu-open");
    }
  });
  

  $(document).keydown(function (e) {
    // ESCAPE key pressed
    if (e.keyCode == 27) {
      $(".menu-item-has-children").removeClass("sub-menu-open");
      $(".sub-menu-wrap").removeClass("sub-menu-open");
      $(".top-nav").removeClass("sub-menu-open");
    }
  });
}

function quicklinksMenu(){
  // Open submenu on click
  $(".js-open-quicklinks").hover(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.js-quicklinks-menu').toggleClass('active');
  });
}


function mobileMenu(){
  // Mobile menu
  $(".mobile-menu-button").on("click", function(e) {
    $(this).toggleClass("is-active");
    
    $('.js-mobile-menu').toggleClass('is-active');

    // Close menu on click outside
    $('body').bind("click touchstart", function(e) {
      if ( $(e.target).closest('.js-mobile-menu').length === 0 &&  $(e.target).closest('.mobile-menu-button').length === 0  ) {
        $('.js-mobile-menu').removeClass('is-active');
        $('.mobile-menu-button').removeClass('is-active');
      }
    });
    $(document).keyup(function(e) {
      if ( e.key === "Escape" || e.key === 'Esc' || e.keyCode === 27 ) {
        if ( $('.js-mobile-menu').hasClass('is-active') ) {
          $('.js-mobile-menu').removeClass('is-active');
          $('.mobile-menu-button').removeClass('is-active');
        }
      }
    });


    // Open sub-nav on click on menu item with children
    $(".js-mobile-menu .menu .menu-item-has-children > a").on("click", function(e) {
      e.preventDefault();
      $(this).parent().find('.sub-menu-wrap').toggleClass('is-active');
    });
    // Close sub-nav on click on back button
    $(".js-mobile-menu .menu .top-level-item .js-back-menu").on("click", function(e) {
      e.preventDefault();
      $(this).parent().toggleClass('is-active');
    });


  });
}


export { mainMenu, quicklinksMenu, mobileMenu };